function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconShareFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.081 5.697v5.854h8.738c1.191 0 2.157.967 2.157 2.156v14.137c0 1.19-.965 2.156-2.157 2.156H6.182a2.158 2.158 0 01-2.158-2.156V13.707c0-1.19.966-2.156 2.158-2.156h8.737V5.693l-2.624 2.624a1.074 1.074 0 01-1.522-.007 1.082 1.082 0 01-.007-1.522l4.475-4.475c.208-.208.48-.313.754-.313l.008.003c.275 0 .548.105.753.31l1.536 1.536 2.939 2.939a1.074 1.074 0 01-.007 1.522c-.422.422-1.11.42-1.522.007l-2.62-2.62zm-2.162 8.016H6.187v14.124h19.626V13.713H17.08v4.508a1.08 1.08 0 01-2.162 0v-4.508zM9.43 11.551v2.162H22.569v-2.162H9.431zm5.488 0h2.162v2.162H14.92v-2.162z",
    fill: props.color
  }));
}

export default SvgIconShareFilled;